import { render, staticRenderFns } from "./PageHeaderText.vue?vue&type=template&id=7ee1c534&"
import script from "./PageHeaderText.vue?vue&type=script&lang=js&"
export * from "./PageHeaderText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports